import BaseService from '../base.service'
export class TranslateService extends BaseService {
  /**
   * The constructor for the ArtistService.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor (parameters = {}) {
    super('api/translate', parameters)
  }
}